import React, {Dispatch, useCallback} from "react";
import {SimpleDropdown} from "../../../common";
import {AnticipatedDischargePageAction} from "./AnticipatedDischargePage";
import {AnticipatedDischargeInfo} from "./domain";

type AnticipatedDischargeSubmitAction =
    'Confirm Discharge Date'
    | 'Update Discharge Date';


const ACTIONS: AnticipatedDischargeSubmitAction[] = [
    'Confirm Discharge Date',
    'Update Discharge Date',
];


type Props = {
    disabled: boolean;
    selectedItems: AnticipatedDischargeInfo[];
    dispatch: Dispatch<AnticipatedDischargePageAction>
}

export function AnticipatedDischargeActionDropdown({
                                                       disabled,
                                                       dispatch,
                                                       selectedItems,
                                                   }: Props) {

    const handleAction = useCallback((action: AnticipatedDischargeSubmitAction) => {
        const actionMap: Record<AnticipatedDischargeSubmitAction, () => void> = {
            'Confirm Discharge Date': () => dispatch({
                type: 'SET_DISCHARGE_MODAL_STATE',
                state: 'confirm',
                selectedItems: selectedItems
            }),
            'Update Discharge Date': () => dispatch({
                type: 'SET_DISCHARGE_MODAL_STATE',
                state: 'update',
                selectedItems: selectedItems
            }),
        };

        actionMap[action]?.();
    }, [dispatch, selectedItems]);

    return (
        disabled ? null :
            <SimpleDropdown
                disabled={disabled}
                options={ACTIONS}
                minWidth={"6rem"}
                selected={''}
                setSelected={(selected) => handleAction(selected as AnticipatedDischargeSubmitAction)}
                maxHeight={"350px"}
                textColor={"black-200"}
                placeholder='Submit'
                isButton
            />
    );
}
